<template>
  <div>
    <!-- 新地形修改 -->
    <MapModal
      :modalNode="modalNode"
      :title="bimVideoCategory.title"
      :id="bimVideoCategory.id"
      :close="videoSurveilClick"
      class="newModelPosition hierarchy1"
      ref="scenerModel"
    >
      <template slot="head">
        <div class="head-operate">
          <el-button type="primary" @click="addGrouping">
            <i class="el-icon-zengjia"></i> 新增分组
          </el-button>
          <el-button type="primary" @click="addPitData">
            <i class="el-icon-zengjia"></i> 新增
          </el-button>
        </div>
      </template>
      <template slot="foot">
        <div class="foot-operate" v-if="selectedScene">
          <el-button type="primary" @click="verification"> 加入场景 </el-button>
        </div>
      </template>
    </MapModal>
    <newGrouping
      v-if="isNewGrouping"
      :isAutoComplete="isAutoComplete"
      :newTerrainDiggingData="newTerrainDiggingData"
      @closeNewGrouping="closeNewGrouping"
      @addNewGroupingSuccess="init"
      ref="newGroupingRef"
    ></newGrouping>
    <newPitData
      v-if="isNewPitData"
      :isPitData="isPitData"
      @closeNewPitData="isNewPitData = false"
      @onSubmitSuccess="init"
    ></newPitData>
  </div>
</template>
<script>
import {
  getBimModelExcavationTreeNodeList,
  deleteBimModelExcavationDetails,
  addBimPlanScenesBusiness,
} from "@/api/api";
import {
  terrainList,
  oneTerrainKid,
  getServeTerrainList,
} from "@/mapUtils/TerrainUtils.js";
import _ from "lodash";
const MapModal = () => import("@/components/common/mapModal/Index");
const newGrouping = () => import("./newGrouping.vue");
const newPitData = () => import("./newPitData.vue");
import { exportExcel } from "@/utils/exportExcel";
export default {
  name: "newTerrainDigging",
  components: { MapModal, newGrouping, newPitData },
  props: {
    offsetY: {
      default: -418,
      type: Number,
    },
    selectedScene: { type: Object },
    getSchemeTree: { type: Function },
    modalNodeData: { type: Array },
    close: {
      type: Function,
    },
    newTerrainDiggingData: {
      default: null,
    },
  },
  data() {
    return {
      bimVideoCategory: {
        title: "环境修改",
        id: "bimVideoCategory", // id和ref使用的同一个
      },
      modalNode: {
        bimVideoCategory: {
          show: true, // 默认展示
          loading: false, // 加载loading

          width: "380px", // 宽度配置 默认450px
          height: `${
            document.querySelector("#mars3d-container").offsetHeight - 180
          }px`, // 配置模态框中心高度
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: true,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
          // 模态框中心配置
          content: {
            type: "tree", // 模态框内容类型 关键
            id: "bimVideoCategoryTree", // id和ref使用的同一个
            name: "title", // 树的展示字段 默认name
            // 配置icon
            i_icon: {
              // level_1: "el-icon-star-off",
              // level_2: "el-icon-gis_dixingkaiwa",
              level_3: "el-icon-gis_dixingkaiwa",
            },
            // 树形Json 后台接受的具体数据 核心
            treeDataJson: [],
            //不需要搜索直接不传
            search: {
              // type: "", //暂时无用 预留字段 后期配置 判断是否是ajax
              keywords: "title", // 搜素配置关键字 默认是name
              // filterNode: this.filterNode, // 搜索的逻辑 可以自己配置
            },
            // nodeClick 事件绑定
            checkeArr: [],
            nodeClick: this.nodeClick,
            checkBox: true,
            expand: false,
            // checkBoxClick: this.checkBoxClick,
          },
          //模态框foot配置
          // foot: {
          //   // addCategory: {
          //   //   type: "button",
          //   //   buttonType: "primary",
          //   //   i_icon: "",
          //   //   title: "添加场景",
          //   //   disabled: false,
          //   //   click: () => this.addCategory(1),
          //   // },
          //   addCategory: {
          //     type: "button",
          //     buttonType: "primary",
          //     i_icon: "el-icon-zengjia",
          //     title: "地形修改",
          //     disabled: false,
          //     click: () => this.addCategory(1),
          //   },
          //   addCategory2: {
          //     type: "button",
          //     buttonType: "primary",
          //     i_icon: "el-icon-zengjia",
          //     title: "模型修改",
          //     disabled: false,
          //     click: () => this.addCategory(2),
          //   },
          // },
        },
      },
      isNewGrouping: false,
      isNewPitData: false,
      isAutoComplete: {
        isShow: true,
      },
      isPitData: {
        isShow: true,
      },
      checkedIds: [],
    };
  },
  watch: {
    modalNodeData: function (newValue, oldValue) {
      if (newValue && newValue[1].children.length > 0) {
        newValue[1].children.forEach((item) => {
          this.checkedIds.push(item.id);
        });
      }
      this.$refs.scenerModel.$refs.modalTree[0].checkChangeArr(this.checkedIds);
    },
  },
  methods: {
    closeNewGrouping() {
      this.isNewGrouping = false;
      this.isAutoComplete = {
        isShow: true,
      };
    },
    //下载
    download(e) {
      if (e.children.length > 0) {
        this.$notify({
          title: "准备导出",
          message: "",
          type: "success",
          duration: 960,
          offset: 320,
        });
        let data = [];
        let excavationDetails;
        e.children.forEach((item, i) => {
          excavationDetails = JSON.parse(
            item.bimModelExcavationDetails.excavationDetails
          ).excavationDetails;
          excavationDetails[excavationDetails.length] = excavationDetails[0];
          data.push(
            ...excavationDetails.map((details) => ({
              x: details[0],
              y: details[1],
              z: details[2],
              index: i,
            }))
          );
        });

        const fields = ["x", "y", "z", "index"];
        const headers = ["x", "y", "z", "index"];
        exportExcel(data, fields, headers, "环境修改数据.xlsx");
      } else {
        this.$notify({
          title: "导出失败，没有数据",
          message: "",
          type: "error",
          duration: 1000,
          offset: 320,
        });
      }
    },
    // 新增分组
    addGrouping(data) {
      this.isNewPitData = false;
      if (data && (data.type == "groupingEdit" || data.type == "parentAdd")) {
        this.isAutoComplete = data.obj.bimModelExcavationDetails;
        this.isAutoComplete.isShow = false;
        if (data.type === "groupingEdit") {
          this.isAutoComplete.groupingEdit = true;
        }
      } else {
        this.isAutoComplete = {
          isShow: true,
        };
      }
      this.isNewGrouping = true;
      // this.$nextTick(() => {
      //   this.$refs.newGroupingRef.editGrouping();
      // });
    },
    // 新增坑数据
    addPitData(data) {
      this.isNewGrouping = false;
      if (data && data.type === "editPitData") {
        this.isPitData = data.obj.bimModelExcavationDetails;
        this.isPitData.isShow = false;
      } else {
        this.isPitData = {
          isShow: true,
        };
      }
      this.isNewPitData = true;
    },
    // 单选 多选 全选 时，挖坑！
    checkBoxClick(data, checked, indeterminate) {
      // 选中
      if (data.parentId != 0 && checked) {
        if (data.children.length == 0) {
          // 新挖坑，然后存储数据在本地
          this.nodeClickAddOneTerrain(data, false);
        }
      }
      // 取消选中
      if (data.parentId != 0 && !checked) {
        if (data.children.length == 0) {
          if (terrainList.length > 0) {
            // 循环本地数据删除对应
            terrainList.forEach((item, index) => {
              if (item.id == data.bimModelExcavationDetails.embsId) {
                item.list.forEach((item2, index2) => {
                  // 获取当前删除的节点下的哪一个坑?
                  if (item2.kId == data.id) {
                    //压平
                    if (item2.typeJudgment == 2) {
                      const model = viewShed.inquire(
                        "modelArray",
                        "modelId",
                        data.bimModelExcavationDetails.embsId
                      );
                      if (
                        model &&
                        model.uid &&
                        this.$GLOBAL.map.hasLayer(model.uid)
                      ) {
                        this.$GLOBAL.tilesetLayer =
                          this.$GLOBAL.map.getLayerById(model.uid);
                        this.$GLOBAL.tilesetLayer.clip.removeArea(item2.uId);
                      } else {
                        this.$GLOBAL.map
                          .getLayer(
                            data.bimModelExcavationDetails.embsId,
                            "modelId"
                          )
                          ?.clip.removeArea(item2.uId);
                      }
                    }
                    // 挖坑
                    if (item2.typeJudgment == 1) {
                      this.$GLOBAL.terrainClip.removeArea(item2.uId);
                    }
                    item.list.splice(index2, 1);
                  }
                });
              }
              if (item.list.length == 0) {
                terrainList.splice(index, 1);
              }
            });
          }
        }
      }
    },
    // 关于节点被点击时，如果公共数据没有内容时候触发
    nodeClickAddOneTerrain(data, isFly) {
      // 存储Id
      oneTerrainKid.kid = data.id;
      // 清除
      this.$GLOBAL.terrainClipGraphic.clear();
      // 获取坐标数据和深度
      const { excavationDetails, depth } = JSON.parse(
        data.bimModelExcavationDetails.excavationDetails
      );
      if (data.bimModelExcavationDetails.pitType == 2) {
        const allValid = excavationDetails.every(
          (element) => typeof element[2] == null || element[2] == 0
        );
        if (allValid) {
          excavationDetails.forEach((element) => {
            element[2] = 3000;
          });
        }
      }

      // 获取整个详细数据
      const embisDetails = data.bimModelExcavationDetails;
      // 创建变量
      let regionalobject;
      // 2 代表是压平
      if (embisDetails.pitType == 2) {
        // 获取模型id
        const model = this.$GLOBAL.map.getLayer(embisDetails.embsId, "modelId");
        // 判断是否存在
        if (model && model.uuid && this.$GLOBAL.map.hasLayer(model.uuid)) {
          // 获取图层
          this.$GLOBAL.tilesetLayer = this.$GLOBAL.map.getLayerById(model.uuid);
          // 给图层里加压平数据
          regionalobject =
            this.$GLOBAL.tilesetLayer.clip.addArea(excavationDetails);
          // 飞过去
          if (isFly) {
            this.$GLOBAL.map.flyToPositions(regionalobject.positions);
          }
          // 查找这个模型下是否之前有坑
          const repeatData = terrainList.find(
            (item) => item.id === data.bimModelExcavationDetails.embsId
          );
          // 有则添加到对应list
          if (repeatData) {
            terrainList.forEach((item) => {
              if (item.id === data.bimModelExcavationDetails.embsId) {
                item.list.push({
                  kId: data.id,
                  uId: regionalobject.id,
                  typeJudgment: data.bimModelExcavationDetails.pitType,
                });
              }
            });
            // 没有则新建对象push进去
          } else {
            // 挖坑存储数据
            const terrainObject = {
              id: embisDetails.embsId,
              list: [],
            };
            terrainObject.list.push({
              kId: data.id,
              uId: regionalobject.id,
              typeJudgment: data.bimModelExcavationDetails.pitType,
            });
            // 存储到公共
            terrainList.push(terrainObject);
          }
        } else {
          this.$notify({
            title: "当前模型不可见!",
            message: "",
            type: "error",
            duration: 960,
            offset: 320,
          });
        }
      } else if (embisDetails.pitType == 1) {
        console.log("挖坑报错");
        // 挖坑
        // 给挖坑添加数据
        regionalobject = this.$GLOBAL.terrainClip.addArea(excavationDetails, {
          diffHeight: depth,
        });
        // 飞过去
        const graphic = this.$GLOBAL.terrainClip.getAreaById(regionalobject.id);
        if (isFly) {
          this.$GLOBAL.map.flyToPositions(graphic.positions);
        }
        // 查找这个模型下是否之前有坑
        const repeatData = terrainList.find(
          (item) => item.id === data.bimModelExcavationDetails.embsId
        );
        // 有则添加到对应list
        if (repeatData) {
          terrainList.forEach((item) => {
            if (item.id === data.bimModelExcavationDetails.embsId) {
              item.list.push({
                kId: data.id,
                uId: regionalobject.id,
                typeJudgment: data.bimModelExcavationDetails.pitType,
              });
            }
          });
          // 没有则新建对象push进去
        } else {
          // 挖坑存储数据
          const terrainObject = {
            id: embisDetails.embsId,
            list: [],
          };
          terrainObject.list.push({
            kId: data.id,
            uId: regionalobject.id,
            typeJudgment: data.bimModelExcavationDetails.pitType,
          });
          // 存储到公共
          terrainList.push(terrainObject);
        }
      }
    },
    // 节点被点击时如果被勾选上且挖过坑，会飞行定位
    nodeClick(data, isFly = true) {
      // 判断当前是子节点
      if (data.parentId !== 0) {
        // 判断公共数据是否有内容
        if (terrainList && terrainList.length > 0) {
          // 判断当前点击的这个节点是不是已经存在公共数据当中find查找
          // 如果已经存在的话代表着此节点此模型已经被加载过，那么对应来说，此模型的坑也加载完毕了
          let currentList = null;
          terrainList.find((item) => {
            if (item.id == data.bimModelExcavationDetails.embsId) {
              item.list.forEach((etem) => {
                if (etem.kId == data.id) {
                  currentList = etem;
                }
              });
            }
          });
          if (currentList) {
            const positions = mars3d.PointTrans.lonlats2cartesians(
              JSON.parse(data.bimModelExcavationDetails.excavationDetails)
                .excavationDetails
            );
            // 直接通过坑坐标飞行过去
            if (isFly) {
              this.$GLOBAL.map.flyToPositions(positions);
            }
          }
        }
      }
    },
    // 关闭当前地形挖坑弹出层
    videoSurveilClick() {
      if (this.$GLOBAL.markDrawGraphicLayer) {
        this.$GLOBAL.markDrawGraphicLayer.clear();
      }
      if (this.$GLOBAL.markDrawGraphicLayer2) {
        this.$GLOBAL.markDrawGraphicLayer2.clear();
      }
      this.$emit("terrainDiggingBox_close");
      if (this.close) {
        this.close("terrain");
      }
    },
    // 删除挖坑数据
    handleDelete(data) {
      // 如果当前是一级节点 有子级存在 则无法删除
      // if (data.children.length > 0) {
      //   this.$notify({
      //     title: "当前节点具有子级,无法删除。",
      //     message: "",
      //     type: "error",
      //     duration: 960,
      //     offset: 320,
      //   });
      // } else {
      this.$confirm("确认删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deleteBimModelExcavationDetails({ id: data.id }).then((res) => {
          if (terrainList.length > 0) {
            terrainList.forEach((item, index) => {
              if (item.id == data.bimModelExcavationDetails.embsId) {
                item.list.forEach((item2, index2) => {
                  // 获取当前删除的节点下的哪一个坑?
                  if (item2.kId == data.id) {
                    //压平
                    if (item2.typeJudgment == 2) {
                      const model = viewShed.inquire(
                        "modelArray",
                        "modelId",
                        data.bimModelExcavationDetails.embsId
                      );
                      if (
                        model &&
                        model.uid &&
                        this.$GLOBAL.map.hasLayer(model.uid)
                      ) {
                        this.$GLOBAL.tilesetLayer =
                          this.$GLOBAL.map.getLayerById(model.uid);
                        this.$GLOBAL.tilesetLayer.clip.removeArea(item2.uId);
                      }
                    }
                    // 挖坑
                    if (item2.typeJudgment == 1) {
                      this.$GLOBAL.terrainClip.removeArea(item2.uId);
                    }
                    item.list.splice(index2, 1);
                  }
                });
              }
              if (item.list.length == 0) {
                terrainList.splice(index, 1);
              }
            });
          }
          this.$notify({
            title: "已成功删除。",
            message: "",
            type: "success",
            duration: 960,
            offset: 320,
          });
          getServeTerrainList();
          // 重新再次调用数据
          this.init();
        });
      });

      // }
    },
    // 眼睛显示隐藏挖洞
    viewArea(data) {
      if (terrainList.length > 0) {
        const model = terrainList.find(
          (item) => item.id == data.bimModelExcavationDetails.embsId
        );
        if (model) {
          if (model.list.find((etem) => etem.kId == data.id)) {
            this.checkBoxClick(data, false);
          } else {
            this.checkBoxClick(data, true);
          }
        } else {
          this.checkBoxClick(data, true);
        }
      } else {
        this.checkBoxClick(data, true);
      }
    },

    viewArea2(item, arr) {
      let isChecked =
        this.$refs.scenerModel.$refs.modalTree[0].$refs.bimVideoCategoryTree.getNode(
          item.id
        ).checked;
      this.isCheck(item, isChecked);
    },

    isCheck(item, isChecked) {
      if (item.children.length > 0) {
        item.children.forEach((data) => {
          this.isCheck(data, isChecked);
        });
      } else {
        this.checkBoxClick(item, isChecked);
        // const model = terrainList.find(
        //   (item) => item.id == data.bimModelExcavationDetails.embsId
        // );
        // console.log(model);
      }
    },

    // 循环处理添加节点icon和事件(只有两级)
    recursiveTree(data) {
      // 一级模型新增
      const addObj = [
        {
          i_icon: "small-operation-btn el-icon-plus",
          click: (e) => this.addGrouping({ obj: e, type: "parentAdd" }),
        },
        {
          i_icon: "small-operation-btn el-icon-delete",
          click: this.handleDelete,
        },
      ];
      // 二级分组新增编辑删除
      const operateGroupingList = [
        {
          i_icon: "small-operation-btn el-icon-plus",
          click: (e) => this.addPitData({ obj: e, type: "editPitData" }),
        },
        {
          i_icon: "small-operation-btn el-icon-edit",
          click: (e) => this.addGrouping({ obj: e, type: "groupingEdit" }),
        },
        {
          i_icon: "small-operation-btn las la-download",
          click: (e) => this.download(e),
        },
        {
          i_icon: "small-operation-btn el-icon-delete",
          click: this.handleDelete,
        },
      ];
      // 三级坑删除
      const deleteObj = {
        i_icon: "small-operation-btn el-icon-delete",
        click: this.handleDelete,
      };
      // 三级眼睛

      // const viewObj = {
      //   i_icon: "small-operation-btn el-icon-view",
      //   click: (e) => this.viewArea(e),
      // };
      let viewObj = {};
      if (this.$route.params.stype.indexOf("sandbox") < 0) {
        //脚本
        viewObj = {
          i_icon: "small-operation-btn el-icon-view",
          click: (e) => this.viewArea(e),
        };
      } else {
        // 沙盘
        viewObj = {};
      }

      // 循环赋值编辑icon和修改name
      if (data.length > 0) {
        data.forEach((item) => {
          item.operate = addObj;
          if (item.children.length > 0) {
            item.children.forEach((item2) => {
              item2.operate = operateGroupingList;
              if (item2.children.length > 0) {
                item2.children.forEach((item3) => {
                  item3.operate = [viewObj, deleteObj];
                  if (item3.bimModelExcavationDetails.pitType == 1) {
                    item3.title = `地形__${item3.title}`;
                  }
                  if (item3.bimModelExcavationDetails.pitType == 2) {
                    item3.title = `模型__${item3.title}`;
                  }
                });
              }
            });
          }
        });
      }
      // 赋值整体数据
      this.modalNode.bimVideoCategory.content.treeDataJson = data;
    },
    // 初始化
    init() {
      this.judgeGlobalTerrain();
      // 获取树形数据
      this.modalNode.bimVideoCategory.loading = true;
      const params = {
        projectId: window.sessionStorage.getItem("nowProjectId"),
      };
      getBimModelExcavationTreeNodeList(params).then((res) => {
        if (res.data.data) {
          this.recursiveTree(res.data.data);

          // 沙盘
          if (this.$route.params.stype.indexOf("sandbox") > -1) {
            this.modalNode.bimVideoCategory.content.check = this.viewArea2;
            console.log(terrainList);
            this.checkedIds = [];
            terrainList[0]?.list.forEach((item) => {
              console.log(item);
              this.checkedIds.push(item.kId);
            });
            console.log(this.checkedIds);
            this.modalNode.bimVideoCategory.content.checkeArr = this.checkedIds;
          } else {
            this.modalNode.bimVideoCategory.content.checkeArr = this.checkedIds;
          }
          this.modalNode.bimVideoCategory.loading = false;
        }
      });
    },
    // 判断全局变量的图层和挖洞工具是否存在
    judgeGlobalTerrain() {
      //创建图层
      if (!this.$GLOBAL.terrainClipGraphic) {
        this.$GLOBAL.terrainClipGraphic = new mars3d.layer.GraphicLayer();
        this.$GLOBAL.map.addLayer(this.$GLOBAL.terrainClipGraphic);
      }
      // 创建挖洞工具
      if (!this.$GLOBAL.terrainClip) {
        this.$GLOBAL.terrainClip = new mars3d.thing.TerrainClip({
          diffHeight: this.depth, //井的深度
          image: "/img/textures/excavate_side_min.png",
          imageBottom: "/img/textures/excavate_bottom_min.jpg",
          splitNum: 80, //井边界插值数
        });
        this.$GLOBAL.map.addThing(this.$GLOBAL.terrainClip);
      }
    },
    // 加入场景
    verification() {
      let currentNode =
        this.$refs.scenerModel.$refs.modalTree[0].getCurrentNode();
      this.modalNode.bimVideoCategory.loading = true;
      let businessId = [];
      currentNode.forEach((item) => {
        businessId.push(item.id);
      });
      let data = {
        // 场景id
        scenesId: this.selectedScene.id,
        // 项目id
        projectId: window.sessionStorage.getItem("nowProjectId"),
        // 业务id
        businessIdLsit: businessId,
        // 业务类型
        businessType: "BimModelExcavationDetails",
      };
      addBimPlanScenesBusiness(data)
        .then((res) => {
          let { code } = res.data;
          if (code == 200 || code == 204) {
            this.modalNode.bimVideoCategory.loading = false;
            this.getSchemeTree();
            this.$notify({
              title: "加入场景成功",
              message: "",
              type: "success",
              duration: 960,
              offset: 320,
            });
          } else {
            this.$notify({
              title: "加入场景失败",
              message: "",
              type: "error",
              duration: 1000,
              offset: 320,
            });
          }
        })
        .catch((error) => {
          this.modalNode.bimVideoCategory.loading = false;
          this.$notify({
            title: "加入场景失败",
            message: "",
            type: "error",
            duration: 1000,
            offset: 320,
          });
        });
    },
  },
  mounted() {
    this.init();
    if (this.modalNode.bimVideoCategory.offset)
      this.modalNode.bimVideoCategory.offset.y = this.offsetY;
  },
};
</script>
<style lang="scss" scoped>
.head-operate {
  padding: 10px 10px;
  margin: 0 -5px !important;
  button {
    margin: 0 5px !important;
  }
}
.foot-operate {
  padding: 10px 10px;
  border-top: 1px solid rgba(245, 245, 245, 0.6) !important;
  justify-content: flex-end;
  align-items: center;
  display: flex;
  /deep/ .el-button {
    margin: 0;
    font-size: 14px;
    padding: 3px 10px;
    line-height: inherit;
    height: auto;
  }
}
.el-button--primary {
  @include button_primary();
  @include button_default();
}
</style>
